export default __webpack_public_path__ + "static/media/Artemis.bad868e9.svg";